module.exports = __webpack_public_path__ + "img/longarrow-left-black.39e23e6b.svg";